import { render, staticRenderFns } from "./StoryTransferModal.vue?vue&type=template&id=16213250&scoped=true"
import script from "./StoryTransferModal.vue?vue&type=script&lang=js"
export * from "./StoryTransferModal.vue?vue&type=script&lang=js"
import style0 from "./StoryTransferModal.vue?vue&type=style&index=0&id=16213250&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16213250",
  null
  
)

export default component.exports